import { render, staticRenderFns } from "./DropdownModel.vue?vue&type=template&id=51f9632e"
import script from "./DropdownModel.vue?vue&type=script&lang=js"
export * from "./DropdownModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports